import { useEffect } from "react";

const SyndeticsEmbed = () => {
  useEffect(() => {
    // remove old script if hot reload injected it
    const oldScript = document.getElementById("syndetics-script");
    if (oldScript) {
      oldScript.remove();
    }

    const script = document.createElement("script");
    script.id = "syndetics-script";
    script.src =
      "https://unbound.syndetics.com/syndeticsunbound/connector/initiator.php?a_id=135";
    script.type = "text/javascript";

    // IMPORTANT: append AFTER component is mounted
    document.body.appendChild(script);

    return () => {
      // optional cleanup
    };
  }, []);

  return (
    <div
      className="ltfl_bookdisplay_widget"
    //   id="ltfl_widget_u_53503910"
    id="ltfl_widget_u_02c7b397"
    />
  );
};

export default SyndeticsEmbed;
